import { fixCorruptedData, getCounts, setDisabledNodes } from '../actions/inventories';
import { isAllLocations, roles, userAllowed } from './utils';
import deviceOverview from '../semantic-ui/site/assets/dashboard/slider/deviceOverview.svg';
import ticketing from '../semantic-ui/site/assets/dashboard/slider/ticketing.svg';
import networkInventory from '../semantic-ui/site/assets/dashboard/slider/networkInventory.svg';
import addUser from '../semantic-ui/site/assets/dashboard/slider/addUser.svg';

import simCardInventory from '../semantic-ui/site/assets/dashboard/slider/simCardInventory.svg';
import averageThroughputs from '../semantic-ui/site/assets/dashboard/slider/averageThroughputs.png';
import recentAlerts from '../semantic-ui/site/assets/dashboard/slider/recentAlerts.png';
import AWSEC2CPUUtilization from '../semantic-ui/site/assets/dashboard/slider/AWSEC2CPUUtilization.png';
import AWSEBSVolReadBytes from '../semantic-ui/site/assets/dashboard/slider/AWSEBSVolReadBytes.png';
import AWSEC2NetworkIn from '../semantic-ui/site/assets/dashboard/slider/AWSEC2NetworkIn.png';
import AWSEC2NetworkOut from '../semantic-ui/site/assets/dashboard/slider/AWSEC2NetworkOut.png';
import AWSOutpostCapacity from '../semantic-ui/site/assets/dashboard/slider/AWSOutpostCapacity.png';
import AWSOutpostConnectedStatus from '../semantic-ui/site/assets/dashboard/slider/AWSOutpostConnectedStatus.png';
import AWSS3BucketSizeBytes from '../semantic-ui/site/assets/dashboard/slider/AWSS3BucketSizeBytes.png';
import AWSS3NumberOfObjects from '../semantic-ui/site/assets/dashboard/slider/AWSS3NumberOfObjects.png';
import AWSEBSVolWriteBytes from '../semantic-ui/site/assets/dashboard/slider/AWSEBSVolWriteBytes.png';

import { KPI_WIDGET_MAP } from '../components/dashboard/largeWidgets/AWSKPIWidget';
import { KPI_TABS } from '../components/mec/osnd/KPIMapping';

export const DEFAULT_REGION = 'us-east-1';

export const WIDGETS_KEYS = {
    DEVICE_OVERVIEW: 'DEVICE_OVERVIEW',
    TICKETING: 'TICKETING',
    SIMS_INVENTORY: 'SIMS_INVENTORY',
    NETWORK_INVENTORY: 'NETWORK_INVENTORY',
    ADD_USER: 'ADD_USER',
    AVERAGE_THROUGHPUTS: 'AVERAGE_THROUGHPUTS',
    RECENT_ALERTS: 'RECENT_ALERTS',
    AWS_OUTPOST_INSTANCE_CAPACITY: 'AWS_OUTPOST_INSTANCE_CAPACITY',
    AWS_OUTPOST_CONNECTED_STATUS: 'AWS_OUTPOST_CONNECTED_STATUS',
    AWS_EC2_CPU_UTILIZATION: 'AWS_EC2_CPU_UTILIZATION',
    AWS_S3_BUCKET_SIZE_BYTES: 'AWS_S3_BUCKET_SIZE_BYTES',
    AWS_S3_NUMBER_OF_OBJECTS: 'AWS_S3_NUMBER_OF_OBJECTS',
    AWS_EBS_VOL_READ_BYTES: 'AWS_EBS_VOL_READ_BYTES',
    AWS_EBS_VOL_WRITE_BYTES: 'AWS_EBS_VOL_WRITE_BYTES',
    AWS_EC2_NETWORK_IN: 'AWS_EC2_NETWORK_IN',
    AWS_EC2_NETWORK_OUT: 'AWS_EC2_NETWORK_OUT'
};

export const WIDGETS = {
    DEVICE_OVERVIEW: 'Device overview',
    TICKETING: 'Total tickets',
    SIMS_INVENTORY: 'SIM inventory',
    NETWORK_INVENTORY: 'Network inventory',
    ADD_USER: 'Add user',
    AVERAGE_THROUGHPUTS: 'Average UL/DL throughputs',
    RECENT_ALERTS: 'Recent alerts',
    AWS_OUTPOST_INSTANCE_CAPACITY: 'AWS Outpost - InstanceFamilyCapacityAvailability',
    AWS_OUTPOST_CONNECTED_STATUS: 'AWS Outpost - ConnectedStatus',
    AWS_EC2_CPU_UTILIZATION: 'AWS EC2 - CPU utilization',
    AWS_S3_BUCKET_SIZE_BYTES: 'AWS S3 - BucketSizeBytes',
    AWS_S3_NUMBER_OF_OBJECTS: 'AWS S3 - NumberOfObjects',
    AWS_EBS_VOL_READ_BYTES: 'EBS - VolumeReadBytes',
    AWS_EBS_VOL_WRITE_BYTES: 'EBS - VolumeWriteBytes',
    AWS_EC2_NETWORK_IN: 'AWS EC2 - NetworkIn',
    AWS_EC2_NETWORK_OUT: 'AWS EC2 - NetworkOut'
};

export const DEFAULT_DASHBOARD_PREFERENCE = (isPMEC, isIBC) => ({
    smallWidgets: [
        {
            id: WIDGETS_KEYS.DEVICE_OVERVIEW,
            header: WIDGETS[WIDGETS_KEYS.DEVICE_OVERVIEW],
            visible: true
        },
        {
            id: WIDGETS_KEYS.TICKETING,
            header: WIDGETS[WIDGETS_KEYS.TICKETING],
            visible: true
        },
        {
            id: WIDGETS_KEYS.SIMS_INVENTORY,
            header: WIDGETS[WIDGETS_KEYS.SIMS_INVENTORY],
            visible: true
        },
        {
            id: WIDGETS_KEYS.NETWORK_INVENTORY,
            header: WIDGETS[WIDGETS_KEYS.NETWORK_INVENTORY],
            visible: false
        },
        {
            id: WIDGETS_KEYS.ADD_USER,
            header: WIDGETS[WIDGETS_KEYS.ADD_USER],
            visible: false
        }
    ],
    largeWidgets: [
        {
            id: WIDGETS_KEYS.AVERAGE_THROUGHPUTS,
            header: WIDGETS[WIDGETS_KEYS.AVERAGE_THROUGHPUTS],
            visible: true
        },
        ...(isIBC
            ? []
            : [
                  {
                      id: WIDGETS_KEYS.RECENT_ALERTS,
                      header: WIDGETS[WIDGETS_KEYS.RECENT_ALERTS],
                      visible: true
                  }
              ]),
        ...(isPMEC
            ? [
                  {
                      id: WIDGETS_KEYS.AWS_OUTPOST_INSTANCE_CAPACITY,
                      header: WIDGETS[WIDGETS_KEYS.AWS_OUTPOST_INSTANCE_CAPACITY],
                      visible: true
                  },
                  {
                      id: WIDGETS_KEYS.AWS_OUTPOST_CONNECTED_STATUS,
                      header: WIDGETS[WIDGETS_KEYS.AWS_OUTPOST_CONNECTED_STATUS],
                      visible: true
                  },
                  {
                      id: WIDGETS_KEYS.AWS_EC2_CPU_UTILIZATION,
                      header: WIDGETS[WIDGETS_KEYS.AWS_EC2_CPU_UTILIZATION],
                      visible: true
                  },
                  {
                      id: WIDGETS_KEYS.AWS_S3_BUCKET_SIZE_BYTES,
                      header: WIDGETS[WIDGETS_KEYS.AWS_S3_BUCKET_SIZE_BYTES],
                      visible: true
                  },
                  {
                      id: WIDGETS_KEYS.AWS_S3_NUMBER_OF_OBJECTS,
                      header: WIDGETS[WIDGETS_KEYS.AWS_S3_NUMBER_OF_OBJECTS],
                      visible: false
                  },
                  {
                      id: WIDGETS_KEYS.AWS_EBS_VOL_READ_BYTES,
                      header: WIDGETS[WIDGETS_KEYS.AWS_EBS_VOL_READ_BYTES],
                      visible: false
                  },
                  {
                      id: WIDGETS_KEYS.AWS_EBS_VOL_WRITE_BYTES,
                      header: WIDGETS[WIDGETS_KEYS.AWS_EBS_VOL_WRITE_BYTES],
                      visible: false
                  },
                  {
                      id: WIDGETS_KEYS.AWS_EC2_NETWORK_IN,
                      header: WIDGETS[WIDGETS_KEYS.AWS_EC2_NETWORK_IN],
                      visible: false
                  },
                  {
                      id: WIDGETS_KEYS.AWS_EC2_NETWORK_OUT,
                      header: WIDGETS[WIDGETS_KEYS.AWS_EC2_NETWORK_OUT],
                      visible: false
                  }
              ]
            : [])
    ]
});

export const DASHBOARD_WIDGET_TYPE = {
    SMALL_WIDGETS: 'smallWidgets',
    LARGE_WIDGETS: 'largeWidgets'
};

export const WIDGETS_TOOLTIP_MAPPING = {
    DEVICE_OVERVIEW: deviceOverview,
    TICKETING: ticketing,
    SIMS_INVENTORY: simCardInventory,
    NETWORK_INVENTORY: networkInventory,
    ADD_USER: addUser,
    AVERAGE_THROUGHPUTS: averageThroughputs,
    RECENT_ALERTS: recentAlerts,
    AWS_OUTPOST_INSTANCE_CAPACITY: AWSOutpostCapacity,
    AWS_OUTPOST_CONNECTED_STATUS: AWSOutpostConnectedStatus,
    AWS_EC2_CPU_UTILIZATION: AWSEC2CPUUtilization,
    AWS_S3_BUCKET_SIZE_BYTES: AWSS3BucketSizeBytes,
    AWS_S3_NUMBER_OF_OBJECTS: AWSS3NumberOfObjects,
    AWS_EBS_VOL_READ_BYTES: AWSEBSVolReadBytes,
    AWS_EBS_VOL_WRITE_BYTES: AWSEBSVolWriteBytes,
    AWS_EC2_NETWORK_IN: AWSEC2NetworkIn,
    AWS_EC2_NETWORK_OUT: AWSEC2NetworkOut
};

export const KPI_MAP = {
    AWS_OUTPOST_CONNECTED_STATUS: {
        key: KPI_TABS.OUTPOST.key,
        namespace: 'AWS/Outposts',
        metric: 'CONNECTEDSTATUS'
    },
    AWS_OUTPOST_INSTANCE_CAPACITY: {
        key: KPI_TABS.OUTPOST.key,
        namespace: 'AWS/Outposts',
        metric: 'INSTANCEFAMILYCAPACITYAVAILABILITY'
    },
    AWS_EC2_CPU_UTILIZATION: {
        key: KPI_TABS.EC2_AWS.key,
        namespace: 'AWS/EC2',
        metric: 'CPUUTILIZATION'
    },
    AWS_S3_BUCKET_SIZE_BYTES: {
        key: KPI_TABS.S3.key,
        namespace: 'AWS/S3',
        metric: 'BUCKETSIZEBYTES'
    },
    AWS_S3_NUMBER_OF_OBJECTS: {
        key: KPI_TABS.S3.key,
        namespace: 'AWS/S3',
        metric: 'NUMBEROFOBJECTS'
    },
    AWS_EBS_VOL_READ_BYTES: {
        key: KPI_TABS.EBS.key,
        namespace: 'AWS/EBS',
        metric: 'VOLUMEREADBYTES'
    },
    AWS_EBS_VOL_WRITE_BYTES: {
        key: KPI_TABS.EBS.key,
        namespace: 'AWS/EBS',
        metric: 'VOLUMEWRITEBYTES'
    },
    AWS_EC2_NETWORK_IN: {
        key: KPI_TABS.EC2_AWS.key,
        namespace: 'AWS/EC2',
        metric: 'NETWORKIN'
    },
    AWS_EC2_NETWORK_OUT: {
        key: KPI_TABS.EC2_AWS.key,
        namespace: 'AWS/EC2',
        metric: 'NETWORKOUT'
    }
};

export const widgetFullList = (isPMEC, isIBC) => ({
    smallWidgets: ['DEVICE_OVERVIEW', 'TICKETING', 'SIMS_INVENTORY', 'NETWORK_INVENTORY', 'ADD_USER'],
    largeWidgets: ['AVERAGE_THROUGHPUTS', ...(isIBC ? [] : ['RECENT_ALERTS']), ...(isPMEC ? Object.keys(KPI_WIDGET_MAP) : [])]
});
export const roleLimitation = (isOSNDMECAllowed) => ({
    //small card
    NETWORK_INVENTORY: [roles.VIEW_INVENTORY],
    FLOOR_PLANS: [roles.MANAGE_FLOOR_PLANS, roles.VIEW_FLOORPLANS],
    ADD_USER: [roles.MANAGE_USERS],
    DEVICE_OVERVIEW: [roles.VIEW_DEVICE_MONITORING, roles.MANAGE_DEVICES],
    LATEST_USAGE_REPORT: [roles.VIEW_MEC_REPORTS, roles.MANAGE_MEC_USAGE_REPORTS],
    TICKETING: [roles.VIEW_TICKETING],
    ASSIGN_ROLE: [roles.MANAGE_USERS],
    // LAST_BACKUP: [roles.VIEW_BACKUPS, roles.MANAGE_BACKUPS],
    // SIMS: [roles.VIEW_SUBSCRIBERS, roles.MANAGE_SUBSCRIBERS],
    // EQUIPMENT_STATUS: [roles.VIEW_INVENTORY],

    //medium card
    SIMS_INVENTORY: [roles.VIEW_SUBSCRIBERS, roles.MANAGE_SUBSCRIBERS, roles.VIEW_SIM_MANAGEMENT],
    PERFORMENCE: [
        roles.MANAGE_4G_ATTACHED_DEVICES,
        roles.MANAGE_5GSA_REGISTERED_DEVICES,
        roles.MANAGE_4G_ATTACH_SUCCESS_RATE,
        roles.MANAGE_5GSA_REGISTRATION_SUCCESS_RATE,
        roles.MANAGE_4G_RAN_UL_THROUGHPUT,
        roles.MANAGE_4G_RAN_DL_THROUGHPUT,
        roles.MANAGE_5G_RAN_UL_THROUGHPUT,
        roles.MANAGE_5G_RAN_DL_THROUGHPUT,
        roles.MANAGE_4G5G_RAN_UL_THROUGHPUT,
        roles.MANAGE_4G5G_RAN_DL_THROUGHPUT,
        roles.MANAGE_4G_CORE_UL_THROUGHPUT,
        roles.MANAGE_4G_CORE_DL_THROUGHPUT,
        roles.MANAGE_5G_CORE_UL_THROUGHPUT,
        roles.MANAGE_5G_CORE_DL_THROUGHPUT
    ],
    ATTACH_RATE: [roles.MANAGE_4G_ATTACH_SUCCESS_RATE, roles.MANAGE_5GSA_REGISTRATION_SUCCESS_RATE],

    //large card - TO DO:microfrontend
    RECENT_ALERTS: [roles.VIEW_MANAGE_ALERTS],
    AVERAGE_THROUGHPUTS: [
        roles.MANAGE_4G_RAN_UL_THROUGHPUT,
        roles.MANAGE_4G_RAN_DL_THROUGHPUT,
        roles.MANAGE_5G_RAN_UL_THROUGHPUT,
        roles.MANAGE_5G_RAN_DL_THROUGHPUT,
        roles.MANAGE_4G5G_RAN_UL_THROUGHPUT,
        roles.MANAGE_4G5G_RAN_DL_THROUGHPUT,
        roles.MANAGE_4G_CORE_UL_THROUGHPUT,
        roles.MANAGE_4G_CORE_DL_THROUGHPUT,
        roles.MANAGE_5G_CORE_UL_THROUGHPUT,
        roles.MANAGE_5G_CORE_DL_THROUGHPUT
    ],
    AWS_OUTPOST: [roles.VIEW_MEC_PERFORMANCE, roles.MANAGE_MEC_PERFORMANCE],
    AWS_EC2: [roles.VIEW_MEC_PERFORMANCE, roles.MANAGE_MEC_PERFORMANCE],
    AWS_S3: [roles.VIEW_MEC_PERFORMANCE, roles.MANAGE_MEC_PERFORMANCE],
    AWS_EBS: [roles.VIEW_MEC_PERFORMANCE, roles.MANAGE_MEC_PERFORMANCE],
    AWS_OUTPOST_CONNECTED_STATUS: [roles.VIEW_MEC_PERFORMANCE, ...(isOSNDMECAllowed ? [] : [roles.MANAGE_MEC_PERFORMANCE])],
    AWS_OUTPOST_INSTANCE_CAPACITY: [roles.VIEW_MEC_PERFORMANCE, ...(isOSNDMECAllowed ? [] : [roles.MANAGE_MEC_PERFORMANCE])],
    AWS_EC2_CPU_UTILIZATION: [roles.VIEW_MEC_PERFORMANCE, ...(isOSNDMECAllowed ? [] : [roles.MANAGE_MEC_PERFORMANCE])],
    AWS_S3_BUCKET_SIZE_BYTES: [roles.VIEW_MEC_PERFORMANCE, ...(isOSNDMECAllowed ? [] : [roles.MANAGE_MEC_PERFORMANCE])],
    AWS_S3_NUMBER_OF_OBJECTS: [roles.VIEW_MEC_PERFORMANCE, ...(isOSNDMECAllowed ? [] : [roles.MANAGE_MEC_PERFORMANCE])],
    AWS_EBS_VOL_READ_BYTES: [roles.VIEW_MEC_PERFORMANCE, ...(isOSNDMECAllowed ? [] : [roles.MANAGE_MEC_PERFORMANCE])],
    AWS_EBS_VOL_WRITE_BYTES: [roles.VIEW_MEC_PERFORMANCE, ...(isOSNDMECAllowed ? [] : [roles.MANAGE_MEC_PERFORMANCE])],
    AWS_EC2_NETWORK_IN: [roles.VIEW_MEC_PERFORMANCE, ...(isOSNDMECAllowed ? [] : [roles.MANAGE_MEC_PERFORMANCE])],
    AWS_EC2_NETWORK_OUT: [roles.VIEW_MEC_PERFORMANCE, ...(isOSNDMECAllowed ? [] : [roles.MANAGE_MEC_PERFORMANCE])]
});

export const widgetMapping = {
    //small card
    DEVICE_OVERVIEW: {
        title: 'Device overview',
        src: deviceOverview
    },
    TICKETING: {
        title: 'Total tickets',
        src: ticketing,
    },
    NETWORK_INVENTORY: {
        title: 'Network inventory',
        src: networkInventory
    },
    ADD_USER: {
        title: 'Add user',
        src: addUser
    },
    SIMS_INVENTORY: {
        title: 'SIM inventory',
        src: simCardInventory
    },

    // large card
    AVERAGE_THROUGHPUTS: {
        title: 'Average UL/DL throughputs',
        src: averageThroughputs
    },
    RECENT_ALERTS: {
        title: 'Recent alerts',
        src: recentAlerts
    },
    AWS_OUTPOST_INSTANCE_CAPACITY: {
        title: 'AWS Outpost / InstanceFamilyCapacityAvailability',
        src: AWSOutpostCapacity
    },
    AWS_OUTPOST_CONNECTED_STATUS: {
        title: 'AWS Outpost / ConnectedStatus',
        src: AWSOutpostConnectedStatus
    },
    AWS_EC2_CPU_UTILIZATION: {
        title: 'AWS EC2 / CPU utilization',
        src: AWSEC2CPUUtilization
    },
    AWS_S3_BUCKET_SIZE_BYTES: {
        title: 'AWS S3 / BucketSizeBytes',
        src: AWSS3BucketSizeBytes
    },
    AWS_S3_NUMBER_OF_OBJECTS: {
        title: 'AWS S3 / NumberOfObjects',
        src: AWSS3NumberOfObjects
    },
    AWS_EBS_VOL_READ_BYTES: {
        title: 'EBS / VolumeReadBytes',
        src: AWSEBSVolReadBytes
    },
    AWS_EBS_VOL_WRITE_BYTES: {
        title: 'EBS / VolumeWriteBytes',
        src: AWSEBSVolWriteBytes
    },
    AWS_EC2_NETWORK_IN: {
        title: 'AWS EC2 / NetworkIn',
        src: AWSEC2NetworkIn
    },
    AWS_EC2_NETWORK_OUT: {
        title: 'AWS EC2 / NetworkOut',
        src: AWSEC2NetworkOut
    }
};
export const isPerformanceManageAllowed = (userRoles) =>
    userAllowed(
        userRoles,
        [
            roles.MANAGE_4G_ATTACHED_DEVICES,
            roles.MANAGE_4G_RAN_UL_THROUGHPUT,
            roles.MANAGE_4G_RAN_DL_THROUGHPUT,
            roles.MANAGE_5G_RAN_UL_THROUGHPUT,
            roles.MANAGE_5G_RAN_DL_THROUGHPUT,
            roles.MANAGE_4G5G_RAN_UL_THROUGHPUT,
            roles.MANAGE_4G5G_RAN_DL_THROUGHPUT,
            roles.MANAGE_4G_CORE_UL_THROUGHPUT,
            roles.MANAGE_4G_CORE_DL_THROUGHPUT,
            roles.MANAGE_4G_ATTACH_SUCCESS_RATE,
            roles.KPI_4GRAN_DATA_ACCESSIBILITY,
            roles.KPI_4GRAN_DATA_MOBILITY,
            roles.KPI_4GRAN_DATA_RETAINABILITY,
            roles.VIEW_KPI_VoLTE_ACCESSIBILITY,
            roles.VIEW_KPI_VoLTE_RETAINABILITY,
            roles.VIEW_KPI_VoLTE_MOBILITY,
            roles.VIEW_KPI_5G_NSA_ACCESSIBILITY,
            roles.VIEW_KPI_5G_NSA_RETAINABILITY,
            roles.VIEW_KPI_5G_NSA_MOBILITY
        ],
        true
    );
export const isPerformanceManageAllowedSA = (userRoles) =>
    userAllowed(
        userRoles,
        [
            roles.MANAGE_5GSA_REGISTERED_DEVICES,
            roles.MANAGE_4G_RAN_UL_THROUGHPUT,
            roles.MANAGE_4G_RAN_DL_THROUGHPUT,
            roles.MANAGE_5G_RAN_UL_THROUGHPUT,
            roles.MANAGE_5G_RAN_DL_THROUGHPUT,
            roles.MANAGE_4G5G_RAN_UL_THROUGHPUT,
            roles.MANAGE_4G5G_RAN_DL_THROUGHPUT,
            roles.MANAGE_5G_CORE_UL_THROUGHPUT,
            roles.MANAGE_5G_CORE_DL_THROUGHPUT,
            roles.MANAGE_5GSA_REGISTRATION_SUCCESS_RATE,
            roles.MANAGE_TOP_DEVICES_EP5G,
            roles.KPI_4GRAN_DATA_ACCESSIBILITY,
            roles.KPI_4GRAN_DATA_MOBILITY,
            roles.KPI_4GRAN_DATA_RETAINABILITY,
            roles.VIEW_KPI_VoLTE_ACCESSIBILITY,
            roles.VIEW_KPI_VoLTE_RETAINABILITY,
            roles.VIEW_KPI_VoLTE_MOBILITY,
            roles.VIEW_KPI_5G_NSA_ACCESSIBILITY,
            roles.VIEW_KPI_5G_NSA_RETAINABILITY,
            roles.VIEW_KPI_5G_NSA_MOBILITY
        ],
        true
    );

export const navTabLicensing = (title, userRoles, isIBC = false, isEP5G = false, isPMEC) => {
    switch (title) {
        case 'Access & Permissions':
            return userAllowed(userRoles, [roles.MANAGE_USERS, roles.VIEW_USERS]);
        case 'SIM management':
            return userAllowed(userRoles, [roles.VIEW_SIM_MANAGEMENT]) && userAllowed(userRoles, [roles.VIEW_BACKUPS, roles.VIEW_SUBSCRIBERS]);
        case 'Network Navigator':
            return userAllowed(userRoles, [roles.VIEW_INVENTORY]);
        case 'Devices':
            return userAllowed(userRoles, [roles.VIEW_DEVICE_MONITORING, roles.MANAGE_DEVICES], false) && !isIBC;
        case 'Performance':
            return (
                userAllowed(userRoles, [roles.VIEW_NETWORK_PERFORMANCE]) &&
                (!isEP5G ? isPerformanceManageAllowed(userRoles) : isPerformanceManageAllowedSA(userRoles))
            );
        case 'MEC Performance':
            return userAllowed(userRoles, [roles.VIEW_MEC_PERFORMANCE, roles.MANAGE_MEC_PERFORMANCE], false) && isPMEC && !isIBC;
        case 'MEC Usage':
            return userAllowed(userRoles, [roles.VIEW_MEC_REPORTS, roles.MANAGE_MEC_USAGE_REPORTS], false) && isPMEC && !isIBC;
        case 'Alerts':
            return userAllowed(userRoles, [roles.VIEW_MANAGE_ALERTS, roles.MANAGE_ALERTS], false);
        case 'Ticketing':
            return userAllowed(userRoles, [roles.VIEW_TICKETING]);
        default:
            return false;
    }
};

export const navTabs = [
    {
        title: 'Access & Permissions',
        intro: 'Add/manage users for OSND access, and configure roles for those users.',
        position: 'right',
        element: '.tour-step-7'
    },
    { title: 'SIM management', intro: 'Configure SIMs and activate before use.', position: 'right', element: '.tour-step-8' },
    {
        title: 'Network Navigator',
        intro: 'View a visual representation and inventory of your network components.',
        position: 'right',
        element: '.tour-step-9'
    },
    { title: 'Devices', intro: 'View information about devices on your network.', position: 'right', element: '.tour-step-10' },
    {
        title: 'Performance',
        intro: 'Here you have options to view network KPIs at an overview level, and at more granular levels.',
        position: 'right',
        element: '.tour-step-11'
    },
    {
        title: 'MEC Performance',
        intro: 'Here you can view Cloud Service Provider metrics for your MEC-enabled deployment.',
        position: 'right',
        element: '.tour-step-12'
    },
    { title: 'MEC Usage', intro: 'Generate cloud usage reports for your MEC-enabled deployment.', position: 'right', element: '.tour-step-13' },
    {
        title: 'Alerts',
        intro: 'Here you can define the alerts you want to receive about your network performance, and customize the notifications for those alerts.',
        position: 'right',
        element: '.tour-step-14'
    },
    {
        title: 'Ticketing',
        intro: 'Submit support tickets or follow up on issues that have already been reported.',
        position: 'right',
        element: '.tour-step-15'
    }
];

export const ticketStatus = [
    { color: '#A40000', value: 'open', status: 'Open' },
    { color: '#FF8027', value: 'permitClose', status: 'Resolved' },
    { color: '#008331', value: 'completed', status: 'Closed' },
    { color: '#FFBC3D', value: 'other', status: 'Other' }
];

export const getImgStyle = (widgetType) => ({
    width: widgetType === 'smallWidgets' ? '381px' : widgetType === 'mediumWidgets' ? '584px' : '558px'
});

export const getBarStyle = (item, index, counts, totalCount) => ({
    backgroundColor: item.color,
    paddingLeft: (counts[item.value] / totalCount) * 100 - (index !== 0 ? 3 : 2) + '%',
    marginLeft: index !== 0 ? 1 : 0
});

export const processwidgetPreference = (visibleWidgetList, userRoles, roleLimitation, isIBC, isNDAC) => {
    const widgetPreference = {};
    Object.entries(visibleWidgetList).forEach(([key, value]) => {
        if (key.includes('Widgets')) {
            widgetPreference[key] = value.filter((item) => {
                if (item === WIDGETS_KEYS.AVERAGE_THROUGHPUTS) {
                    return (
                        !isAllLocations() &&
                        userAllowed(userRoles, [roles.VIEW_NETWORK_PERFORMANCE]) &&
                        userAllowed(userRoles, roleLimitation[item]) &&
                        !isIBC
                    );
                } else if (item === WIDGETS_KEYS.RECENT_ALERTS) {
                    return !isAllLocations() && userAllowed(userRoles, [roles.VIEW_MANAGE_ALERTS, roles.MANAGE_ALERTS], false);
                } else if (item === WIDGETS_KEYS.FLOOR_PLANS) {
                    return (
                        userAllowed(userRoles, [roles.MANAGE_FLOOR_PLANS, roles.VIEW_FLOORPLANS], false) ||
                        userAllowed(userRoles, [roles.MANAGE_OUTDOOR_MAP])
                    );
                } else if (item === WIDGETS_KEYS.SIMS_INVENTORY) {
                    return userAllowed(userRoles, [roles.VIEW_SUBSCRIBERS, roles.VIEW_SIM_MANAGEMENT], false);
                } else {
                    // don't display sim inventory and recent alerts on IBC enterprise
                    // const isAllowedWithAllLocations =
                    //     isAllLocations() && [WIDGETS_KEYS.DEVICE_OVERVIEW, WIDGETS_KEYS.TICKETING, WIDGETS_KEYS.SIMS_INVENTORY].includes(item);
                    const isNetworkInventoryAllLocations = WIDGETS_KEYS.NETWORK_INVENTORY === item && isAllLocations();
                    const isAddUserAllLocations = WIDGETS_KEYS.ADD_USER === item && isAllLocations();
                    const isKpiWidgetAllLocations = Object.keys(KPI_WIDGET_MAP).includes(item) && isAllLocations();
                    const isIBCRestrictedItem =
                        (item === WIDGETS_KEYS.SIMS_INVENTORY || item === WIDGETS_KEYS.RECENT_ALERTS || item === WIDGETS_KEYS.DEVICE_OVERVIEW) &&
                        isIBC;
                    const isUserAllowedForItem = userAllowed(
                        userRoles,
                        roleLimitation[item],
                        item !== WIDGETS_KEYS.DEVICE_OVERVIEW &&
                            item !== WIDGETS_KEYS.LATEST_USAGE_REPORT &&
                            !Object.keys(KPI_WIDGET_MAP).includes(item)
                    );
                    return (
                        !isIBCRestrictedItem &&
                        isUserAllowedForItem &&
                        // Below condition is to not show the widgets when user has all locations access
                        !isNetworkInventoryAllLocations &&
                        !isAddUserAllLocations &&
                        !isKpiWidgetAllLocations
                    );
                }
            });
        }
    });

    return {
        widgetPreference
    };
};

export const getWidgetsByRoles = (widgets, userRoles, roleLimitation, isIBC, isPMEC) => {
    const result = widgets.filter(({ id: widget }) => {
        if (widget === 'AVERAGE_THROUGHPUTS') {
            return userAllowed(userRoles, [roles.VIEW_NETWORK_PERFORMANCE]) && userAllowed(userRoles, roleLimitation[widget]) && !isIBC;
        } else if (widget === 'RECENT_ALERTS') {
            return userAllowed(userRoles, [roles.VIEW_MANAGE_ALERTS, roles.MANAGE_ALERTS], false);
        } else if (widget === 'SIMS_INVENTORY') {
            return userAllowed(userRoles, [roles.VIEW_SIM_MANAGEMENT]);
        } else if (Object.keys(KPI_WIDGET_MAP).includes(widget)) {
            // for pmec widgets check addon and pmec roles both
            return isPMEC && userAllowed(userRoles, roleLimitation[widget]);
        }
        return (
            // don't display sim inventory and recent alerts on IBC enterprise
            !((widget === 'SIMS_INVENTORY' || widget === 'RECENT_ALERTS' || widget === 'DEVICE_OVERVIEW') && isIBC) &&
            userAllowed(userRoles, roleLimitation[widget], widget !== 'DEVICE_OVERVIEW')
        );
    });

    return result;
};

export const decorateNetworkInventory = (inventory, network, isManageAllowed5G, solutionType, userRoles) => {
    let counts = getCounts(inventory.networks, solutionType, userRoles);
    if (counts.TOTAL > 0) {
        let updatedNetworks = fixCorruptedData(inventory?.networks);
        setDisabledNodes(updatedNetworks, inventory?.ldps, isManageAllowed5G, solutionType);
        counts = getCounts(updatedNetworks, solutionType, userRoles);
    }
    return {
        radio: counts.RADIO_NETWORK,
        core: counts.CORE_NETWORK,
        total: counts.TOTAL,
        physical: counts.PHYSICAL,
        virtual: counts.VIRTUAL
    };
};

export const decorateFloorPlan = (ibWave) => {
    // Remove floor plans with no components. Ex. "Aerial"
    return {
        buildingName: ibWave.buildings[0].buildingName,
        floorPlanName: ibWave.buildings[0].floorPlans[0].floorPlanName,
        fileLocation: ibWave.buildings[0].floorPlans[0].fileLocation
    };
};

export const decorateEquipmentStatus = (inventory, solutionType, userRoles) => {
    let enabled = 0,
        disabled = 0;
    if (inventory.networks[1]?.parentNodes?.length > 0) {
        inventory.networks[1].parentNodes.forEach((d) => {
            if (d.nodeList?.length > 0) {
                d.nodeList
                    ?.filter((el) => el)
                    .forEach((node) => {
                        if (node.operationalState === 'ENABLED') {
                            enabled++;
                        } else if (node.operationalState === 'DISABLED') {
                            disabled++;
                        }
                    });
            }
        });
    }
    const counts = getCounts(inventory.networks, solutionType, userRoles);
    return {
        enabled,
        disabled,
        radioCount: counts.RADIO_NETWORK
    };
};

export const decorateAttachKPI = (viewThresholdOverAllKpi, kpiType) => {
    const { overallKPIS } = viewThresholdOverAllKpi;
    const value = overallKPIS?.find((item) => item.kpiType === kpiType)?.value;
    if (value === undefined) {
        return false;
    } else {
        return kpiType === 'ATTACH_SUCCESS' ? Math.round(Number(value) * 1000) / 10 : Number(value);
    }
};

export const processValue = (data) => {
    if (!data) return [];
    const valueArray = data.map((d) => Math.ceil(d.value) || 1.0);
    const maxValue = Math.max(...valueArray) < 0 ? 1 : Math.max(...valueArray);

    data.map((item) => {
        if (!item?.value) {
            item.value = 0;
        } else {
            const numValue = Math.round(item.value);
            if (numValue === -1) {
                item.NoData = maxValue;
                item.value = undefined;
            } else {
                item.value = numValue;
            }
        }
    });

    return data;
};

export const processGraphData = (throughputData, title, color, symbol) => {
    const graphData = [];
    if (throughputData?.uplinkMetrics?.length > 0 || throughputData?.downlinkMetrics?.length > 0) {
        const uplinkData = processValue(throughputData?.uplinkMetrics);
        const downlinkData = processValue(throughputData?.downlinkMetrics);

        [downlinkData, uplinkData].map((item, index) =>
            graphData.push({
                title: title[index],
                data: item,
                color: color[index],
                symbol: symbol[index]
            })
        );
    }
    return graphData;
};

export const generateKpiKeys = (MECWidgets = []) => {
    const kpiKeys = {};
    MECWidgets.forEach((widget) => {
        const { namespace, metric } = KPI_MAP[widget];
        if (!kpiKeys[namespace]) {
            kpiKeys[namespace] = [];
        }
        kpiKeys[namespace].push(metric);
    });

    return kpiKeys;
};

export const getSortedOrderBasedOnCondition = (inputArr, condition) => {
    const matchingElements = inputArr.filter((el) => condition(el));
    const nonMatchingElements = inputArr.filter((el) => !condition(el));
    const result = matchingElements.concat(nonMatchingElements);

    return result;
};

export const getPrefferedWidgets = (allWidgets, selectedWidgets) => {
    const headingWidgets = selectedWidgets.filter((selectedWidget) => selectedWidget.visible);
    const tailingWidgets = allWidgets
        .filter((defaultWidget) => !headingWidgets.map((el) => el.id).includes(defaultWidget.id))
        ?.map((el) => ({ ...el, visible: false }));
    return headingWidgets.concat(tailingWidgets);
};
